import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Button, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import { Box } from '@mui/system';
import { useEffect } from 'react';
import { DefaultValues, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { selectCurrentToken } from './authSlice';
import AuthCard from './components/AuthCard';
import AuthContainer from './components/AuthContainer';

export type FormValues = {
	newPassword: string;
	confirmPassword: string;
};

export const defaultValues: DefaultValues<FormValues> = {
	newPassword: '',
	confirmPassword: '',
};

export default function ResetPasswordSuccessPage() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const token = useSelector(selectCurrentToken);

	const { handleSubmit, control } = useForm<FormValues>({
		defaultValues,
	});

	const onSubmit: SubmitHandler<FormValues> = async () => {
		navigate('/login');
	};

	// useEffect(() => {
	// 	if (!token) {
	// 		navigate('/forgot-password');
	// 	}
	// }, [token]);

	return (
		<AuthContainer>
			<AuthCard title={t('forgotPassword.resetPasswordTitle')} message={''}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<Typography
						fontSize='24px'
						// variant='bold'
						marginTop='22px'
						whiteSpace='nowrap'
						color={'#28A745'}
					>
						{t('forgotPassword.resetFixSuccess')}
					</Typography>
					<Box sx={{ display: 'flex', justifyContent: 'center' }}>
						<Button
							fullWidth
							type='submit'
							variant='contained'
							sx={{
								width: '240px',
								marginTop: '40px',
								bgcolor: 'transparent',
								background: 'linear-gradient(to right, #FBCC4E, #FC9381) ',
							}}
						>
							{t('button.signInAgain')}
						</Button>
					</Box>
				</form>
			</AuthCard>
		</AuthContainer>
	);
}
